import React 			from 'react';
import PropTypes 	from 'prop-types';

import BLComponent from '../core/_BLComponent.jsx';

export default class MultilineEllipsis extends BLComponent {
	constructor(props) {
		super(props);
	}

	render() {
		const {classes = '', lines = 'auto'} = this.props;

		return (
			<div className={"multiline-overflow multiline-overflow--" + lines + "-lines " + classes}>
				<div>{this.props.children}</div>
			</div>
		);
	}
}

MultilineEllipsis.propTypes = {
		classes: PropTypes.string
	,	lines: PropTypes.oneOf([2, 3, 4, 5])
};